/**
 * 根據 ID 滾動到指定的元素
 *
 * @param option: { offset: 偏移值, behavior: 滾動行為 }
 * @returns { handleScrollTo: 根據 ID 滾動到指定的元素 }
 */

interface IOption {
  offset?: number;
  behavior?: ScrollBehavior;
}

export function useScrollTo(option?: IOption) {
  const { y } = useScrollValue({ behavior: option?.behavior || 'smooth' });

  /**
   * 根據 ID 滾動到指定的元素
   * @param id: 元素的 ID，未填寫則滾動到頂部
   * @returns void
   */

  const handleScrollTo = (id?: string, customOffset?: number): void => {
    if (!id) {
      y.value = 0;
      return;
    }

    const element: HTMLElement | null = document.querySelector(`#${id}`);

    if (element) {
      const offset = customOffset || option?.offset || 0;
      const rect = element.getBoundingClientRect();
      const targetY = rect.top + y.value - offset;
      y.value = targetY;
    }
  };

  return { handleScrollTo };
}
